/* tslint:disable */
/* eslint-disable */
export enum WorkUserLanguageEnum {
  De = 'de',
  Fr = 'fr',
  It = 'it',
  En = 'en'
}
